(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_8037d32"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('language-welcome')) return;
  const key = 'b2b_language_welcome_v1';
  const lifetime = 365 * 24 * 60 * 60 * 1000;
  let remembered = false;
  let active = null;
  function hasChoice() {
    if (remembered) return true;
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const record = JSON.parse(window[name].getItem(key));
        if (record && Number.isFinite(record.at) && Date.now() - record.at < lifetime && record.at <= Date.now()) return true;
      } catch {}
    }
    return false;
  }
  function remember() {
    remembered = true;
    for (const name of ['localStorage', 'sessionStorage']) {
      try { window[name].setItem(key, JSON.stringify({at: Date.now()})); } catch {}
    }
  }
  class LanguageWelcome extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.dataset.preview === 'true' || hasChoice()) return;
      this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.dialog.addEventListener('cancel', event => {event.preventDefault(); this.dismiss();}, options);
      this.querySelector('form').addEventListener('submit', event => {
        if (!event.submitter || event.submitter.name !== 'language_code') {event.preventDefault(); return;}
        remember();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (active === this) active = null;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll:true});
      }, options);
      this.attempts = 0;
      this.timer = setTimeout(() => this.show(), 800);
    }
    show() {
      if (!this.isConnected || hasChoice() || active) return;
      if (document.visibilityState === 'hidden' || document.querySelector('dialog[open]')) {
        if (++this.attempts < 120) this.timer = setTimeout(() => this.show(), 1000);
        return;
      }
      if (typeof this.dialog.showModal !== 'function') return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      active = this;
      this.querySelector('.language-welcome-current, .language-welcome-options button')?.focus();
    }
    dismiss() {remember(); this.dialog.close();}
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      if (active === this) active = null;
    }
  }
  customElements.define('language-welcome', LanguageWelcome);
})();
  } catch(e) { console.error(e); }
})();

})();
